import { render, staticRenderFns } from "./ParcellePopup.vue?vue&type=template&id=124a9202&scoped=true"
import script from "./ParcellePopup.vue?vue&type=script&lang=js"
export * from "./ParcellePopup.vue?vue&type=script&lang=js"
import style0 from "./ParcellePopup.vue?vue&type=style&index=0&id=124a9202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124a9202",
  null
  
)

export default component.exports